import "./TermsAndConditions.module.css";
import Header from "@/reusable_sections/Header";
import MancheteDoDia from "./sections/MancheteDoDia";
import Our25YearTrajectory from "./sections/Our25YearTrajectory";
import Footer from "@/reusable_sections/Footer";
export default function TermsAndConditionsPage() {
  return <div>
      <Header />
      <MancheteDoDia />
      <Our25YearTrajectory />
      <Footer />
    </div>;
}